export default {
    ADD: 'add',
    MULTIPLY: 'multi',
    EPIC_ADD: 'epicAdd',
    EPIC_MULTIPLIY: 'epicMulti',
    EXPAND: 'expand',
    GRID_WIN: 'gridwin',
    BONUS: 'bonusfeaturewon'
}